import { useState } from 'react';
import './LeadsFilter.css';
import { sourceOptions } from '../../utilities/services/formOptions';
import { getAllLeads } from '../../utilities/api/leads';
import { capitalizeFirstLetter } from '../../utilities/services/capitalizeFirstLetter';

const defaultLeadsFilters = {
    "source": "",
    "status": "",
    "province": "",
    "createdAtStart": "",
    "createdAtEnd": "",
    "updatedAtStart": "",
    "updatedAtEnd": "",
}

const statusOptions = [
    "active",
    "dead",
    "hot",
    "converted"
]

const provinceOptions = [
    "AB",
    "BC",
    "MB",
    "NB",
    "NL",
    "NS",
    "NT",
    "NU",
    "ON",
    "PE",
    "QC",
    "SK",
    "YT",
]

export default function LeadsFilter({ updateLeads, isMobile, sortHeader }) {
    const [filter, setFilter] = useState(defaultLeadsFilters)
    const [loading, setLoading] = useState(false)

    const getLeads = async () => {
        try {
            const allLeads = await getAllLeads()
            return allLeads.sort((a, b) => a[sortHeader] < b[sortHeader] ? 1 : -1)
        } catch (error) {
            console.log(error)
        }
    }

    const resetFilter = async () => {
        setLoading(true)
        // clear content of all input fields
        const form = document.getElementById('leadsFilter');
        for (let i = 0; i < form.elements.length; i++) {
            if (form.elements[i].type === 'text' || form.elements[i].type === 'date' || form.elements[i].type === 'select-one') {
                form.elements[i].value = '';
            }
        }
        setFilter(defaultLeadsFilters)
        const freshLeadsData = await getLeads();
        updateLeads(freshLeadsData)
        setLoading(false)
    }

    const filterLeads = async () => {
        setLoading(true)
        const freshLeadsData = await getLeads();
        const cleanedFilter = Object.keys(filter).reduce((acc, key) => {
            if (filter[key]) {
                acc[key] = filter[key];
            }
            return acc;
        }, {});

        const updatedLeadsList = freshLeadsData.filter(lead => {
            return (
                (cleanedFilter.source ? lead.source === cleanedFilter.source.toLowerCase() : true) &&
                (cleanedFilter.status ? lead.status === cleanedFilter.status : true) &&
                (cleanedFilter.province ? lead.province === cleanedFilter.province : true) &&
                (cleanedFilter.createdAtStart ? new Date(lead.createdAt) >= new Date(cleanedFilter.createdAtStart) : true) &&
                (cleanedFilter.createdAtEnd ? new Date(lead.createdAt) <= new Date(cleanedFilter.createdAtEnd) : true) &&
                (cleanedFilter.updatedAtStart ? new Date(lead.updatedAt) >= new Date(cleanedFilter.updatedAtStart) : true) &&
                (cleanedFilter.updatedAtEnd ? new Date(lead.updatedAt) <= new Date(cleanedFilter.updatedAtEnd) : true)
            );
        });

        updateLeads(updatedLeadsList);
        setLoading(false)
    }

    const handleChange = (evt) => {
        const newFilterData = {
            ...filter,
            [evt.target.name]: evt.target.value
        }
        setFilter(newFilterData)
    }
  return (
    <div className='LeadsFilter dropdown leadsFilterDropDown'>
        <button className='leadsFilterDropDownToggle' id='leadsFilterDropDownToggle' title='Leads Filter' data-title='Leads Filter' data-bs-toggle="dropdown" data-bs-auto-close='outside' aria-expanded="false">
            <svg width="16" height="20" viewBox="0 0 17 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M3.5 6H13.5M1 1H16M6 11H11" stroke="#1B2B41" strokeWidth="1.67" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
            { !isMobile && <span>Filters</span> }
        </button>
        <div className='dropdown-menu leadsFilterDropDown' aria-labelledby="leadsFilterDropDownToggle">
            <div className='header'>
                <div className='svgContainer'>
                    <svg width="16" height="20" viewBox="0 0 17 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M3.5 6H13.5M1 1H16M6 11H11" stroke="#1B2B41" strokeWidth="1.67" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                </div>
                <span>Filters</span>
            </div>
            <form id='leadsFilter'>
                <div className='form-group'>
                    <label htmlFor="source" className='form-label'>Source</label>
                    <select id="source" name='source' className='form-select' onChange={handleChange}>
                        <option value="">Show All</option>
                        { sourceOptions.map((source, index) => (
                            <option key={index} value={source}>{source}</option>
                        ))}
                    </select>
                </div>
                <div className='form-group'>
                    <label htmlFor="status" className='form-label'>Status</label>
                    <select id="status" name='status' className='form-select' onChange={handleChange}>
                        <option value="">Show All</option>
                        { statusOptions.map((status, index) => (
                            <option key={index} value={status}>{capitalizeFirstLetter(status)}</option>
                        ))}
                    </select>
                </div>
                <div className='form-group'>
                    <label htmlFor="province" className='form-label'>Province</label>
                    <select id="province" name='province' className='form-select' onChange={handleChange}>
                        <option value="">Show All</option>
                        { provinceOptions.map((province, index) => (
                            <option key={index} value={province}>{capitalizeFirstLetter(province)}</option>
                        ))}
                    </select>
                </div>
                <div>Creation Date</div>
                <div className='form-group split'>
                    <div>
                        <label htmlFor="createdAtStart" className='form-label'>Start</label>
                        <input type="date" id="createdAtStart" name='createdAtStart' className='form-control' onChange={handleChange} />
                    </div>
                    <div>
                        <label htmlFor="createdAtEnd" className='form-label'>End</label>
                        <input type="date" id="createdAtEnd" name='createdAtEnd' className='form-control' onChange={handleChange} />
                    </div>
                </div>
                <div>Last Update</div>
                <div className='form-group split'>
                    <div>
                        <label htmlFor="updatedAtStart" className='form-label'>Start</label>
                        <input type="date" id="updatedAtStart" name='updatedAtStart' className='form-control' onChange={handleChange} />
                    </div>
                    <div>
                        <label htmlFor="updatedAtEnd" className='form-label'>End</label>
                        <input type="date" id="updatedAtEnd" name='updatedAtEnd' className='form-control' onChange={handleChange} />
                    </div>
                </div>
            </form>
            <div className='buttonContainer'>
                <button className='btn btn-primary' type='button' onClick={filterLeads} form='leadsFilter' disabled={loading}>Filter</button>
                <button className='btn btn-secondary' type='reset' form='leadsFilter' onClick={resetFilter} disabled={loading}>Reset</button>
            </div>
        </div>
    </div>
  )
}
